import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
//import { fetchHexonAds } from '../actions';
import { fetchHexonAds, fetchHexonImages } from '../actions';
import { FETCH_HEXON } from '../constants';
import { selectHexonAds } from '../selectors';
import { HexonAdsItem } from './AdsItem';

const Container = styled.div`
  .item-row {
    > div {
      width: 150px;
    }
    > div:first-child {
      width: 100px;
    }
    > div:nth-child(2) {
      width: 100px;
    }
  }
`;

const STATE = {
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class HexonAdsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.get();
  }

  handlePageChange = newPage => {
    this.setState({ currentPage: newPage }, this.props.get(newPage));
  };

  render() {
    if (this.props.loading) return <Loader small />;
    console.log(this.props.ads);

    const ads = _.orderBy(this.props.ads, a => parseInt(a.stocknumber, 10));
    return (
      <Container>
        <VBox>
          {ads.map((item, index) => (
            <>
              <HexonAdsItem key={index} ad={item} spaced={ads[index - 1]?.stocknumber != item.stocknumber} />
            </>
          ))}
        </VBox>
      </Container>
    );
  }
}

HexonAdsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    ads: selectHexonAds(),
    loading: selectWorks([FETCH_HEXON]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get(page) {
      dispatch(fetchHexonAds(page));
      //dispatch(fetchHexonImages(page));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const HexonAds = compose(
  withRouter,
  withConnect,
)(HexonAdsComp);
